
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { GetServerSideProps } from "next";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import HeaderMenu from "@/components/HeaderMenu";
import VerticalCardImg from "@/components/VerticalCardImg";
import Footer from "@/components/Footer";
import { handleError } from "@/helpers/handleError";
import { notFoundSemCache } from "@/helpers/notFoundSemCache";
import { BlogPostsMainData, BreadcrumbType } from "@/Types/types";
import { configFile } from "@/config";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbInitial } from "@/data/breadcrumbInitial";
import { GET_HEADER_DATA } from "@/graphql/headerQueries";
import Pagination from "@/components/Pagination";
import { GET_CATEGORY, GET_CATEGORY_PAGINATION } from "@/graphql/categoryQueries";
import { ONE_DAY_IN_SECONDS } from "@/constants/timeConstants";
export default function CategoryPage(props: any) {
    const [pageUrl, setPageUrl] = useState<any>();
    const [page, setPage] = useState<number>();
    const [counter, setCounter] = useState<number>();
    const [pageCount, setPageCount] = useState<number>();
    const [prevHref, setPrevHref] = useState<string>();
    const [isPrevDisabled, setIsPrevDisabled] = useState<boolean>();
    const [isNextDisabled, setIsNextDisabled] = useState<boolean>();
    const [isPagination, setIsPagination] = useState<boolean>();
    const router = useRouter();
    useEffect(() => {
        setIsPrevDisabled(page === 1);
        props &&
            setIsNextDisabled(page === props.categoryPosts.meta.pagination.pageCount);
        if (pageUrl !== undefined) {
            if (page !== 1) {
                router.push({
                    pathname: `/categoria/${props.category.data[0].attributes.slug}`,
                    query: { page: page }
                }, `/categoria/${props.category.data[0].attributes.slug}?page=${page}`, { shallow: false });
            }
            if (page === 1) {
                router.push({
                    pathname: `/categoria/${props.category.data[0].attributes.slug}`
                }, `/categoria/${props.category.data[0].attributes.slug}`, { shallow: false });
            }
        }
    }, [page]);
    const handleClick = useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        if (page === 2) {
            setPrevHref(`/categoria/${props.category.data[0].attributes.slug}`);
        }
        else if (page === 1) {
            setPrevHref("");
        }
        else {
            setPrevHref(`/categoria/${props.category.data[0].attributes.slug}?page=${page! - 1}`);
        }
    }, [page]);
    useEffect(() => {
        setPageUrl(props.category.data[0].attributes.slug);
        setCounter(props.categoryPosts.meta.pagination.total);
        setPageCount(props.categoryPosts.meta.pagination.pageCount);
        setIsPagination(props.categoryPosts.meta.pagination.pageCount > 1);
        if (router.isReady) {
            setPage(+(router.query.page as unknown as number) || 1);
        }
    }, [router.query.slug, router.query.page]);
    return (<>
      <HeaderMenu cookies={props.cookies.data} menu={props.navbar.data?.attributes.header_links}/>
      <NextSeo title={props.category.data[0].attributes.metaTitle} description={props.category.data[0].attributes.metaDescription} canonical={props.category.data[0].attributes.canonicalURL}/>
      <Box maxWidth="1216px" margin="0 auto" width="90%" mb="32px" as="header" pt={'32px'}>
        <Breadcrumbs data={props.breadcrumbs}/>
        <Heading mb="32px" as="h1" fontWeight="800" position="relative">
          {props.category.data[0]?.attributes.title}
          <Text as="span" bgColor={configFile.primaryAccentColor} height="20px" color="#fff" display="inline-flex" fontWeight="700" fontSize="12px" lineHeight="16px" justifyContent="center" alignItems="center" position="relative" ml="20px" top="-5px" padding="0 5px">
            {counter}
          </Text>
        </Heading>
        <Text color="gray.600" fontSize="20px" lineHeight="28px">
          {props.category.data[0]?.attributes.description}
        </Text>
      </Box>
      <Flex maxWidth="1216px" margin="0 auto" width="90%" columnGap="32px" rowGap="32px" flexWrap="wrap" pb={{ base: "44px", lg: "64px" }} justifyContent="flex-start">
        {props.categoryPosts.data.map((item: BlogPostsMainData, index: number) => (<VerticalCardImg notMainPage key={index} item={item}/>))}
      </Flex>
      {isPagination && (<Pagination slug={"categoria/" + pageUrl} handleClick={handleClick} isNextDisabled={isNextDisabled} isPrevDisabled={isPrevDisabled} page={page} pageCount={pageCount} prevHref={prevHref} setPage={setPage}/>)}
      <Footer menu={props.footer[0].items}/>
    </>);
}
const getServerSideProps: GetServerSideProps = async (context) => {
    try {
        context.res.setHeader("Cache-Control", `public, s-maxage=${ONE_DAY_IN_SECONDS}, immutable`);
        const client = new ApolloClient({
            uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
            cache: new InMemoryCache()
        });
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: categoryData } = await client.query({
            query: GET_CATEGORY,
            variables: {
                slugUrl: context.params?.slug
            }
        });
        if (!categoryData.category.data.length) {
            return notFoundSemCache(context.res);
        }
        const { data: categoryPosts } = await client.query({
            query: GET_CATEGORY_PAGINATION,
            variables: {
                slugUrl: context.params?.slug,
                page: (context.query?.page && +context.query?.page) || 1
            }
        });
        const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));
        breadcrumbs.push({
            href: `/categoria/${categoryData.category.data[0].attributes.slug}`,
            label: `${categoryData.category.data[0].attributes.metaTitle}`
        });
        return {
            props: { ...categoryPosts, ...categoryData, ...headerData, breadcrumbs }
        };
    }
    catch (error) {
        handleError(error, "Categoria Slug getServerSideProps");
        return notFoundSemCache(context.res);
    }
};

    async function __Next_Translate__getServerSideProps__1a1756ceefe__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/categoria/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1756ceefe__ as getServerSideProps }
  